var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.683,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.505 18.005L12.495.665a1.327 1.327 0 00-2.3 0L.178 18.005a1.329 1.329 0 001.152 1.994h20.025a1.329 1.329 0 001.15-1.994zm-.966.771a.206.206 0 01-.186.109H1.328a.227.227 0 01-.184-.322l10.012-17.34a.213.213 0 01.372 0l10.011 17.34a.2.2 0 010 .213zm-9.1-2.073a1.028 1.028 0 11-.3-.73 1.03 1.03 0 01.298.73zM11.41 6.168a1.334 1.334 0 011.329 1.336 1.422 1.422 0 01-.02.227l-.608 6.495a.7.7 0 01-1.4 0l-.616-6.495a1.284 1.284 0 01-.02-.227 1.334 1.334 0 011.336-1.336z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/Warning.d56785fc2c022fddde9935d60b60df89.svg";
export { SvgWarning as ReactComponent };